import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import FormLabel from "@mui/material/FormLabel";
import Alert from "@mui/material/Alert";
import FormGroup from "@mui/material/FormGroup";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import EditIcon from "@material-ui/icons/Edit";
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditCred = (props) => {
  window.sessionStorage.setItem("CredID", props.CredID);
  const [state, setState] = React.useState({
    name: "",
    description: "",
    auth_method: "",
    username: "",
    password: "",
    ssh_key: "",
    os_type: "",
    provider: "",
    accesskeyid: "",
    secretaccesskey: "",
    clientid: "",
    secret: "",
    serviceaccjson: "",
    kubeconfig: "",    
    kerberos: "",
    domain_name: "",
    ad_server: "",
    errorMessage: "",
    showPassword: false,
  });

  const [subnav, setSubnav] = useState(false);

  const showSubnav = () => {
    setSubnav(!subnav);
    if (subnav) {
      const id = "kerberos";
      setState((prevState) => ({
        ...prevState,
        [id]: "no",
      }));
    } else {
      const id = "kerberos";
      setState((prevState) => ({
        ...prevState,
        [id]: "yes",
      }));
    }
  };

  const [userlist, setusers] = useState([]);

  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  useEffect(() => {
    const CredID = props.CredID;
    fetch(`${process.env.REACT_APP_API_URL}/api/credentials/${CredID}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          setusers(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, [props.CredID]);

  const handleClickShowPassword = () => {
    setState({
      ...state,
      showPassword: !state.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    // const NodeRSA = require("node-rsa");
    if (userlist.provider === "os") {
      if (state.username === "") {
        if (state.os_type === "windows" || userlist.os_type === "windows") {
          const register = {
            name: state.name,
            description: state.description,
            auth_method: state.auth_method,
            username: state.username,
            password: state.password,
            ssh_key: state.ssh_key,
            os_type: state.os_type,
            kerberos: userlist.kerberos,
            domain_name: state.domain_name,
            ad_server: state.ad_server,
            provider: state.provider,
            accesskeyid: state.accesskeyid,
            secretaccesskey: state.secretaccesskey,
            clientid: state.clientid,
            secret: state.secret,
            serviceaccjson: state.serviceaccjson,
            kubeconfig: state.kubeconfig            
          };
          const CredID = props.CredID;
          fetch(`${process.env.REACT_APP_API_URL}/api/credentials/${CredID}/`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + window.localStorage.getItem("token"),
            },
            body: JSON.stringify(register),
          })
            .then((response) => response.json())
            .then((data) => {
              window.location.reload();
              window.location.href = "/admin/credentials";
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          if (state.ssh_key) {
            const pemKey = state.ssh_key;
            var lines = pemKey.split("\n");
            var OpenkeyType = "";
            var EndkeyType = "";
            for (var i = 0; i < lines.length; i++) {
              if (lines[i] === "-----BEGIN RSA PRIVATE KEY-----") {
                OpenkeyType = "RSAprivate";
              } else if (lines[i] === "-----BEGIN PRIVATE KEY-----") {
                OpenkeyType = "PRIVATE";
              } else if (lines[i] === "-----BEGIN OPENSSH PRIVATE KEY-----") {
                OpenkeyType = "OPENSSHprivate";
              } else if (lines[i] === "-----END RSA PRIVATE KEY-----") {
                EndkeyType = "RSAprivate";
              } else if (lines[i] === "-----END PRIVATE KEY-----") {
                EndkeyType = "PRIVATE";
              } else if (lines[i] === "-----END OPENSSH PRIVATE KEY-----") {
                EndkeyType = "OPENSSHprivate";
              }
            }
            if (
              (OpenkeyType === "RSAprivate" && EndkeyType === "RSAprivate") ||
              (OpenkeyType === "PRIVATE" && EndkeyType === "PRIVATE") ||
              (OpenkeyType === "OPENSSHprivate" &&
                EndkeyType === "OPENSSHprivate")
            ) {
              const register = {
                name: state.name,
                description: state.description,
                auth_method: state.auth_method,
                username: state.username,
                password: state.password,
                ssh_key: state.ssh_key,
                os_type: state.os_type,
                provider: state.provider,
                accesskeyid: state.accesskeyid,
                secretaccesskey: state.secretaccesskey,
                clientid: state.clientid,
                secret: state.secret,
                serviceaccjson: state.serviceaccjson,
                kubeconfig: state.kubeconfig                
              };
              const CredID = props.CredID;
              fetch(
                `${process.env.REACT_APP_API_URL}/api/credentials/${CredID}/`,
                {
                  method: "PUT",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer " + window.localStorage.getItem("token"),
                  },
                  body: JSON.stringify(register),
                }
              )
                .then((response) => response.json())
                .then((data) => {
                  window.location.reload();
                  window.location.href = "/admin/credentials";
                })
                .catch((error) => {
                  console.error(error);
                });
            } else {
              setState({
                errorMessage: "Invalid key, Please enter the key in PEM format",
              });
            }
          } else {
            const register = {
              name: state.name,
              description: state.description,
              auth_method: state.auth_method,
              username: state.username,
              password: state.password,
              ssh_key: state.ssh_key,
              os_type: state.os_type,
              provider: state.provider,
              accesskeyid: state.accesskeyid,
              secretaccesskey: state.secretaccesskey,
              clientid: state.clientid,
              secret: state.secret,
              serviceaccjson: state.serviceaccjson,
              kubeconfig: state.kubeconfig              
            };
            const CredID = props.CredID;
            fetch(`${process.env.REACT_APP_API_URL}/api/credentials/${CredID}/`, {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + window.localStorage.getItem("token"),
              },
              body: JSON.stringify(register),
            })
              .then((response) => response.json())
              .then((data) => {
                window.location.reload();
                window.location.href = "/admin/credentials";
              })
              .catch((error) => {
                console.error(error);
              });
          }
        }
      } else {
        if (state.os_type === "") {
          if (
            ((state.username === "Administrator" ||
              state.username === "administrator") &&
              userlist.os_type === "windows") ||
            ((state.username === "Root" || state.username === "root") &&
              userlist.os_type === "linux")
          ) {
            if (state.os_type === "windows") {
              setState({
                errorMessage:
                  "For security reasons Administrator user is not allowed in Windows!",
              });
            } else {
              setState({
                errorMessage:
                  "For security reasons root user is not allowed in Linux!",
              });
            }
          } else {
            if (/^[A-Za-z][A-Za-z0-9-_.]*$/.test(state.username)) {
              const register = {
                name: state.name,
                description: state.description,
                auth_method: state.auth_method,
                username: state.username,
                password: state.password,
                ssh_key: state.ssh_key,
                os_type: state.os_type,
                provider: state.provider,
                accesskeyid: state.accesskeyid,
                secretaccesskey: state.secretaccesskey,
                clientid: state.clientid,
                secret: state.secret,
                serviceaccjson: state.serviceaccjson,
                kubeconfig: state.kubeconfig                
              };
              const CredID = props.CredID;
              fetch(
                `${process.env.REACT_APP_API_URL}/api/credentials/${CredID}/`,
                {
                  method: "PUT",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer " + window.localStorage.getItem("token"),
                  },
                  body: JSON.stringify(register),
                }
              )
                .then((response) => response.json())
                .then((data) => {
                  window.location.reload();
                  window.location.href = "/admin/credentials";
                })
                .catch((error) => {
                  console.error(error);
                });
            } else {
              setState({
                errorMessage: "Special characters is not allowed in username!",
              });
            }
          }
        } else {
          if (
            ((state.username === "Administrator" ||
              state.username === "administrator") &&
              state.os_type === "windows") ||
            ((state.username === "Root" || state.username === "root") &&
              state.os_type === "linux")
          ) {
            if (state.os_type === "windows") {
              setState({
                errorMessage:
                  "For security reasons administrator user is not allowed in Windows!",
              });
            } else {
              setState({
                errorMessage:
                  "For security reasons root user is not allowed in Linux!",
              });
            }
          } else {
            if (
              /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/.test(state.username)
            ) {
              if (state.os_type === "windows" || userlist.os_type === "windows") {
                const register = {
                  name: state.name,
                  description: state.description,
                  auth_method: state.auth_method,
                  username: state.username,
                  password: state.password,
                  ssh_key: state.ssh_key,
                  os_type: state.os_type,
                  kerberos: userlist.kerberos,
                  domain_name: state.domain_name,
                  ad_server: state.ad_server,
                  provider: state.provider,
                  accesskeyid: state.accesskeyid,
                  secretaccesskey: state.secretaccesskey,
                  clientid: state.clientid,
                  secret: state.secret,
                  serviceaccjson: state.serviceaccjson,
                  kubeconfig: state.kubeconfig                  
                };
                const CredID = props.CredID;
                fetch(
                  `${process.env.REACT_APP_API_URL}/api/credentials/${CredID}/`,
                  {
                    method: "PUT",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization:
                        "Bearer " + window.localStorage.getItem("token"),
                    },
                    body: JSON.stringify(register),
                  }
                )
                  .then((response) => response.json())
                  .then((data) => {
                    window.location.reload();
                    window.location.href = "/admin/credentials";
                  })
                  .catch((error) => {
                    console.error(error);
                  });
              } else {
                if (state.ssh_key) {
                  const pemKey = state.ssh_key;
                  var liness = pemKey.split("\n");
                  var OpenkeyType = "";
                  var EndkeyType = "";
                  for (var i = 0; i < lines.length; i++) {
                    if (lines[i] === "-----BEGIN RSA PRIVATE KEY-----") {
                      OpenkeyType = "RSAprivate";
                    } else if (lines[i] === "-----BEGIN PRIVATE KEY-----") {
                      OpenkeyType = "PRIVATE";
                    } else if (
                      lines[i] === "-----BEGIN OPENSSH PRIVATE KEY-----"
                    ) {
                      OpenkeyType = "OPENSSHprivate";
                    } else if (lines[i] === "-----END RSA PRIVATE KEY-----") {
                      EndkeyType = "RSAprivate";
                    } else if (lines[i] === "-----END PRIVATE KEY-----") {
                      EndkeyType = "PRIVATE";
                    } else if (lines[i] === "-----END OPENSSH PRIVATE KEY-----") {
                      EndkeyType = "OPENSSHprivate";
                    }
                  }
                  if (
                    (OpenkeyType === "RSAprivate" &&
                      EndkeyType === "RSAprivate") ||
                    (OpenkeyType === "PRIVATE" && EndkeyType === "PRIVATE") ||
                    (OpenkeyType === "OPENSSHprivate" &&
                      EndkeyType === "OPENSSHprivate")
                  ) {
                    const register = {
                      name: state.name,
                      description: state.description,
                      auth_method: state.auth_method,
                      username: state.username,
                      password: state.password,
                      ssh_key: state.ssh_key,
                      os_type: state.os_type,
                      provider: state.provider,
                      accesskeyid: state.accesskeyid,
                      secretaccesskey: state.secretaccesskey,
                      clientid: state.clientid,
                      secret: state.secret,
                      serviceaccjson: state.serviceaccjson,
                      kubeconfig: state.kubeconfig                      
                    };
                    const CredID = props.CredID;
                    fetch(
                      `${process.env.REACT_APP_API_URL}/api/credentials/${CredID}/`,
                      {
                        method: "PUT",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer " + window.localStorage.getItem("token"),
                        },
                        body: JSON.stringify(register),
                      }
                    )
                      .then((response) => response.json())
                      .then((data) => {
                        window.location.reload();
                        window.location.href = "/admin/credentials";
                      })
                      .catch((error) => {
                        console.error(error);
                      });
                  } else {
                    setState({
                      errorMessage:
                        "Invalid key, Please enter the valid PEM key.",
                    });
                  }
                } else {
                  const register = {
                    name: state.name,
                    description: state.description,
                    auth_method: state.auth_method,
                    username: state.username,
                    password: state.password,
                    ssh_key: state.ssh_key,
                    os_type: state.os_type,
                    provider: state.provider,
                    accesskeyid: state.accesskeyid,
                    secretaccesskey: state.secretaccesskey,
                    clientid: state.clientid,
                    secret: state.secret,
                    serviceaccjson: state.serviceaccjson,
                    kubeconfig: state.kubeconfig                    
                  };
                  const CredID = props.CredID;
                  fetch(
                    `${process.env.REACT_APP_API_URL}/api/credentials/${CredID}/`,
                    {
                      method: "PUT",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer " + window.localStorage.getItem("token"),
                      },
                      body: JSON.stringify(register),
                    }
                  )
                    .then((response) => response.json())
                    .then((data) => {
                      window.location.reload();
                      window.location.href = "/admin/credentials";
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                }
              }
            } else {
              setState({
                errorMessage:
                  "special characters is not allowed in username field!",
              });
            }
          }
        }
      }
    } else {
      const register = {
        name: state.name,
        description: state.description,
        auth_method: "password",
        username: state.username,
        password: state.password,
        ssh_key: state.ssh_key,
        os_type: state.os_type,
        kerberos: state.kerberos,
        domain_name: state.domain_name,
        ad_server: state.ad_server,
        provider: state.provider,
        accesskeyid: state.accesskeyid,
        secretaccesskey: state.secretaccesskey,
        clientid: state.clientid,
        secret: state.secret,
        serviceaccjson: state.serviceaccjson,
        kubeconfig: state.kubeconfig
      };
      const CredID = props.CredID;
      fetch(
        `${process.env.REACT_APP_API_URL}/api/credentials/${CredID}/`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer " + window.localStorage.getItem("token"),
          },
          body: JSON.stringify(register),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          window.location.reload();
          window.location.href = "/admin/credentials";
        })
        .catch((error) => {
          console.error(error);
        });      
    }  
  };

  const [open, setOpen] = React.useState(false);
  const toggle = () => {
    setOpen(!open);
  };

  return (
    <>
      <IconButton
        title="Edit"
        aria-label="edit"
        id="edit"
        style={{ padding: "0px", color: "#6b6f6b" }}
      >
        <EditIcon fontSize="small" onClick={toggle} />
      </IconButton>
      <Dialog
        PaperProps={{
          sx: {
            width: "80%",
          },
        }}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <div>
            {state.errorMessage && (
              <Alert color="danger" isOpen={visible} toggle={onDismiss}>
                {" "}
                {state.errorMessage}{" "}
              </Alert>
            )}
          </div>
          <h2
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "810",
              color: "rgb(48, 68, 115)",
              fontFamily: "sans-serif",
              lineHeight: "4.5rem",
            }}
          >
            EDIT CREDENTIAL
          </h2>

          <FormGroup style={{ marginBottom: "2rem" }}>
            <FormLabel htmlFor="name">
              <strong>Name</strong>
            </FormLabel>

            <TextField
              htmlFor="name"
              placeholder={userlist.name}
              id="name"
              className="form-control"
              variant="outlined"
              size="small"
              fullwidth
              value={state.name}
              onChange={handleChange}
              type="text"
              name="name"
              fullWidth
            />
          </FormGroup>

          <FormGroup style={{ marginBottom: "2rem" }}>
            <FormLabel htmlFor="description">
              <strong>Description</strong>
            </FormLabel>
            <TextField
              htmlFor="description"
              placeholder={userlist.description}
              id="description"
              className="form-control"
              variant="outlined"
              size="small"
              fullwidth
              value={state.description}
              onChange={handleChange}
              type="text"
              name="description"
              fullWidth
            />
          </FormGroup>
          <br />
      {userlist.provider == "os" ? (
              <React.Fragment>
          <FormGroup style={{ marginBottom: "2rem" }}>
            <FormLabel htmlFor="os_type">
              <strong> OS type</strong>
            </FormLabel>
            <TextField
              className="form-control"
              type="select"
              id="os_type"
              placeholder={userlist.os_type}
              name="os_type"
              value={state.os_type}
              onChange={handleChange}
              variant="outlined"
              size="small"
              fullWidth
              required
              select
              SelectProps={{ native: true }}
            >
              {userlist.os_type === "windows" ? (
                <React.Fragment>
                  <option value="windows">Windows</option>
                  <option value="linux">Linux</option>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <option value="linux">Linux</option>
                  <option value="windows">Windows</option>
                </React.Fragment>
              )}
            </TextField>
          </FormGroup>

          <FormGroup style={{ marginBottom: "2.5rem" }}>
            <FormLabel htmlFor="username">
              <strong>Username</strong>
            </FormLabel>
            <TextField
              htmlFor="username"
              placeholder={userlist.username}
              id="username"
              className="form-control"
              variant="outlined"
              size="small"
              fullwidth
              value={state.username}
              onChange={handleChange}
              type="text"
              name="username"
              fullWidth
            />

            {state.os_type === "windows" ? (
              <p style={{ marginLeft: "32px" }} align="left">
                <h5>
                  <strong>Hint:</strong> don't use Administrator User
                </h5>
              </p>
            ) : state.os_type === "linux" ? (
              <p style={{ marginLeft: "32px" }} align="left">
                <h5>
                  <strong>Hint:</strong> don't use Root User
                </h5>
              </p>
            ) : (
              ""
            )}
            {userlist.os_type === "windows" && state.os_type === "" ? (
              <p style={{ marginLeft: "32px" }} align="left">
                <h5>
                  <strong>Hint:</strong> don't use Administrator User
                </h5>
              </p>
            ) : userlist.os_type === "linux" && state.os_type === "" ? (
              <p style={{ marginLeft: "32px" }} align="left">
                <h5>
                  <strong>Hint:</strong> don't use Root User
                </h5>
              </p>
            ) : (
              ""
            )}
          </FormGroup>
          <FormGroup style={{ marginBottom: "2.5rem" }}>
            <FormLabel htmlFor="auth_method">
              <strong>Authentication Method</strong>
            </FormLabel>
            <TextField
              className="form-control"
              type="select"
              id="auth_method"
              placeholder={userlist.auth_method}
              name="username"
              value={state.auth_method}
              onChange={handleChange}
              variant="outlined"
              size="small"
              fullWidth
              SelectProps={{ native: true }}
              required
              select
            >
              {state.os_type === "windows" ? (
                <React.Fragment>
                  <option value="password">PasswordAuthentication</option>
                </React.Fragment>
              ) : (
                ""
              )}
              {state.os_type === "linux" ? (
                <React.Fragment>
                  <option value="password">PasswordAuthentication</option>
                  <option value="sshkey">KeyAuthentication</option>
                </React.Fragment>
              ) : (
                ""
              )}
              {userlist.auth_method === "password" &&
              userlist.os_type === "linux" &&
              state.os_type === "" ? (
                <React.Fragment>
                  <option value="password">PasswordAuthentication</option>
                  <option value="sshkey">KeyAuthentication</option>
                </React.Fragment>
              ) : userlist.auth_method === "sshkey" &&
                userlist.os_type === "linux" &&
                state.os_type === "" ? (
                <React.Fragment>
                  <option value="sshkey">KeyAuthentication</option>
                  <option value="password">PasswordAuthentication</option>
                </React.Fragment>
              ) : (
                ""
              )}
              {userlist.auth_method === "password" &&
              userlist.os_type === "windows" &&
              state.os_type === "" ? (
                <React.Fragment>
                  <option value="password">PasswordAuthentication</option>
                </React.Fragment>
              ) : (
                ""
              )}
            </TextField>
          </FormGroup>
          {state.auth_method === "password" ||
          (state.auth_method !== "sshkey" &&
            userlist.auth_method === "password") ? (
            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <FormLabel htmlFor="password">
                <strong>Password</strong>
              </FormLabel>
              <OutlinedInput
                htmlFor="password"
                placeholder="Enter the password ..."
                type={state.showPassword ? "text" : "password"}
                autoComplete="new-password"
                name="password"
                id="password"
                className="form-control"
                value={state.password}
                onChange={handleChange}
                size="small"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {state.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormGroup>
          ) : (
            ""
          )}
          {state.auth_method === "sshkey" ||
          (state.auth_method !== "password" &&
            userlist.auth_method === "sshkey") ? (
            // <React.Fragment>
            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <FormLabel htmlFor="ssh_key">
                <strong>Ssh_Key</strong>
              </FormLabel>
              <TextField
                style={{ marginLeft: "32px", width: "86%" }}
                multiline
                rows={3}
                htmlFor="ssh_key"
                placeholder="Enter the ssh key ..."
                type="text"
                autoComplete="new-ssh_key"
                name="ssh_key"
                id="ssh_key"
                className="form-control"
                value={state.ssh_key}
                onChange={handleChange}
                variant="outlined"
                size="small"
                fullWidth
              />
            </FormGroup>
          ) : (
            ""
          )}
          {state.os_type !== "linux" &&
          userlist.os_type === "windows" &&
          userlist.kerberos === "yes" ? (
            <React.Fragment>
              <FormGroup>
                <FormLabel htmlFor="domain name">
                   <strong>Domain Name</strong>
                </FormLabel>
                <TextField
                  className="form-control"
                  type="text"
                  id="domain_name"
                  placeholder={userlist.domain_name}
                  name="domain_name"
                  value={state.domain_name}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              </FormGroup>
              <br />
              <FormGroup>
                <FormLabel htmlFor="ad server">
                   <strong>AD Server</strong>
                </FormLabel>
                <TextField
                  className="form-control"
                  type="text"
                  id="ad_server"
                  placeholder={userlist.ad_server}
                  name="ad_server"
                  value={state.ad_server}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              </FormGroup>
              <br />
            </React.Fragment>
          ) : (
            ""
          )}
              </React.Fragment>
            ) : userlist.provider == "kubernetes" ? (
              <React.Fragment>
                <FormGroup>
                  <FormLabel htmlFor="kubeconfig">
                     <strong>Kube Config</strong>
                  </FormLabel>
                  <TextField
                    // style={{ marginLeft: "15px", width: "90%" }}
                    multiline
                    rows={3}
                    htmlFor="kubeconfig"
                    placeholder={userlist.kubeconfig}
                    type="text"
                    autoComplete="new-kubeconfig"
                    name="kubeconfig"
                    id="kubeconfig"
                    className="form-control"
                    value={state.kubeconfig}
                    onChange={handleChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <FormLabel htmlFor="kubeconfig">
                     <strong>Hint:</strong>
                    Ensure you are giving the correct config for cluster
                  </FormLabel>
                </FormGroup>
              </React.Fragment>
            ) : (
              <React.Fragment>  
                <FormGroup style={{ marginBottom: "1.5rem" }}>
                  <FormLabel htmlFor="Cloud">
                    <strong>Provider</strong>
                  </FormLabel>
                  <TextField
                    className="form-control"
                    type="select"
                    id="provider"
                    placeholder={userlist.provider}
                    name="provider"
                    value={state.provider}
                    onChange={handleChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                    required
                    select
                    SelectProps={{ native: true }}
                  >
                    {" "}
                    <option>{userlist.provider}</option>
                  </TextField>
                </FormGroup>
                {userlist.provider == "aws" ? (
                  <React.Fragment>
                    <FormGroup>
                      <FormLabel htmlFor="accesskeyid">
                        <strong>AccessKeyID</strong>
                      </FormLabel>
                      <TextField
                        fullWidth
                        type="text"
                        id="accesskeyid"
                        className="form-control"
                        value={state.accesskeyid}
                        onChange={handleChange}
                        variant="outlined"
                        size="small"
                        placeholder={userlist.accesskeyid}
                      />
                    </FormGroup>
                    <br />
                    <FormGroup>
                      <FormLabel htmlFor="secretaccesskey">
                        <strong>SecretAccessKey</strong>
                      </FormLabel>
                      <TextField
                        fullWidth
                        type="text"
                        id="secretaccesskey"
                        className="form-control"
                        value={state.secretaccesskey}
                        onChange={handleChange}
                        variant="outlined"
                        size="small"
                        placeholder={userlist.secretaccesskey}
                      />
                    </FormGroup>
                  </React.Fragment>
                ) : userlist.provider == "azure" ? (
                  <React.Fragment>
                    <FormGroup>
                      <FormLabel htmlFor="clientid">
                        <strong>Client ID</strong>
                      </FormLabel>
                      <TextField
                        fullWidth
                        type="text"
                        id="clientid"
                        className="form-control"
                        value={state.clientid}
                        onChange={handleChange}
                        variant="outlined"
                        size="small"
                        placeholder={userlist.clientid}
                      />
                    </FormGroup>
                    <br />
                    <FormGroup>
                      <FormLabel htmlFor="secret">
                        <strong>Secret</strong>
                      </FormLabel>
                      <TextField
                        fullWidth
                        type="text"
                        id="secret"
                        className="form-control"
                        value={state.secret}
                        onChange={handleChange}
                        variant="outlined"
                        size="small"
                        placeholder={userlist.secret}
                      />
                    </FormGroup>
                  </React.Fragment>
                ) : userlist.provider == "gcp" ? (
                  <React.Fragment>
                    <FormGroup>
                      <FormLabel htmlFor="serviceaccjson">
                         <strong>Service A/C Json</strong>
                      </FormLabel>
                      <TextField
                        // style={{ marginLeft: "15px", width: "90%" }}
                        multiline
                        rows={3}
                        htmlFor="serviceaccjson"
                        placeholder={userlist.serviceaccjson}
                        type="text"
                        autoComplete="new-serviceaccjson"
                        name="serviceaccjson"
                        id="serviceaccjson"
                        className="form-control"
                        value={state.serviceaccjson}
                        onChange={handleChange}
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                      <FormLabel htmlFor="serviceaccjson">
                         <strong>Hint:</strong>
                        Ensure you are giving the correct Json for service
                        account
                      </FormLabel>
                    </FormGroup>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </React.Fragment>
            )}{" "}

        </DialogContent>
        <DialogActions>
          <button
            className="bg-blueGray-100 text-black font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={() => {
              toggle();
              window.location.reload();
            }}
          >
            Cancel
          </button>
          <button
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={handleSubmitClick}
          >
            Update
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditCred;